import { css } from "@emotion/react";
import { colors } from "./colors";

export default css`
  html {
    font-size: 10px;
  }

  html,
  body {
    min-width: 300px;
    font-family: Matter;
  }

  body {
    font-size: 1.4rem;
    background: #f6f6f6;
  }

  body,
  button {
    font-variant-ligatures: none;
  }

  hr {
    background: ${colors.grayAnatomyLight4};
    opacity: 1;
    margin: 0;
  }

  ul li {
    margin: 1rem 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  label,
  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: Matter;
  }

  a {
    color: ${colors.purpleRainBase};

    &:hover {
      color: ${colors.purpleRainDark1};
    }
  }

  p {
    margin-top: 1rem;
  }

  .modal.show {
    transition: all 0.3s ease;
  }

  .modal:has(+ .offcanvas) {
    transform: translateX(-20rem);
  }

  .offcanvas {
    z-index: 5006;
    color: ${colors.purpleRainDark2};
  }

  .offcanvas-end {
    border: 0;
    box-shadow: 0 2px 24px 0 rgba(0, 0, 0, 0.08);
    width: 40rem;
  }

  .offcanvas-body {
    padding: 2rem 2rem;
  }

  .offcanvas-header {
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.06);
    padding: 2rem 2rem;
    color: inheirt;
  }

  .offcanvas-title.h5 {
    font-size: 2rem;
    font-weight: 500;
    line-height: normal;
  }

  .modal .modal-dialog .modal-content .modal-body {
    @media only screen and (max-width: 1000px) {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }

  .modal .modal-dialog .modal-content .modal-header .modal-title {
    margin-top: 1.5rem;

    @media only screen and (max-width: 1000px) {
      padding-left: 2rem;
    }
  }

  .modal .modal-dialog .modal-content .modal-footer {
    @media only screen and (max-width: 1000px) {
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }
`;
